//#region redux
import { ThunkDispatch } from "redux-thunk";
import { displayDialog } from "store/actions/utilActions";
import { useDispatch } from "react-redux";
//#endregion
//#region types
import { LocalizationHelperInstance } from "utils/helpers";
import { IconDefinitionConstants, CampaignConstants } from "utils/constants";
import { DialogEnums, StyleEnums } from "models/enums";
import { DialogProps } from "models/propTypes/dialogPropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import TipDialogContent from "./dialogContent";
import SummerCampaignDialogContent from "./summerCampaignDialogContent";
//#endregion

function useTipDialog() {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();

  const openDialog = async () => {
    const isSummerCampaign = CampaignConstants.isSummerCampaign2026Active(new Date());
    const dialog: DialogProps = {
      isOpen: false,
      title: LocalizationHelperInstance.getFormattedMessage(
        isSummerCampaign ? TranslationKeys.Common.TipDialogTitleSummer2026 : TranslationKeys.Common.TipDialogTitle
      ),
      titleIcon: IconDefinitionConstants.WCommentDots,
      dialogType: DialogEnums.DialogType.WalkingMan,
      type: StyleEnums.DisplayType.Info,
      children: isSummerCampaign ? <SummerCampaignDialogContent /> : <TipDialogContent />,
      maxWidth: "sm",
    };

    dispatch(displayDialog(dialog));
  };

  return {
    openDialog: openDialog,
  };
}

export default useTipDialog;
